/**
 * Mobile-device detection for routing staff to the mobile shell on phones.
 *
 * Viewport width is the reliable signal for "phone-sized screen" — touch alone
 * misfires on touch laptops. 820px catches phones + small tablets in portrait.
 *
 * Staff can override with the "الموقع الكامل (Desktop)" link, which sets a
 * sticky localStorage flag so the router guard stops auto-bouncing them to /m.
 */
const FORCE_DESKTOP_KEY = 'hr_force_desktop'

export function isMobileDevice() {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(max-width: 820px)').matches
}

export function isForceDesktop() {
  try { return localStorage.getItem(FORCE_DESKTOP_KEY) === '1' } catch { return false }
}

export function setForceDesktop(on) {
  try {
    if (on) localStorage.setItem(FORCE_DESKTOP_KEY, '1')
    else localStorage.removeItem(FORCE_DESKTOP_KEY)
  } catch { /* storage unavailable — best effort */ }
}
